var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eb1649df-2768-4f3f-9048-c8a88a08c320",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.05 15.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f49c472f-386d-4e8e-8dc8-91e67b617b16",
    "data-name": "a-chat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "af3beb9b-f564-4bd0-9bc1-351f4b51da81",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1",
    className: "b945f852-4d4b-4900-9123-eb6df184042f",
    d: "M14.71,0H1.34A1.34,1.34,0,0,0,0,1.34V10a1.34,1.34,0,0,0,1.34,1.34h2v4l5.35-4h6A1.34,1.34,0,0,0,16.05,10V1.34A1.34,1.34,0,0,0,14.71,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat2);
export default __webpack_public_path__ + "static/media/chat-2.dc290ec5afcea3239f83755f81522e2a.svg";
export { ForwardRef as ReactComponent };